import styled from 'styled-components';

import { Flex, gridSizes, textSizes } from 'utils/style';

import Filters from 'components/orders/Filters/container';

export default styled(Filters)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 6px;

  .input {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
  }

  .input {
    ${Flex.row};
    padding-left: ${gridSizes('L')};
    flex: 1;
    justify-content: flex-end;

    > div {
      flex: 1;
      max-width: 180px;
      margin-right: 0;
      position: relative;
    }
  }

  .sub-text {
    font-size: ${textSizes('M')};
    color: var(--grey700);
  }
`;
